export default "__VITE_ASSET__dN8KCV9X__"